export default {
  purchaseReturnList: [],
  purchaseReturnInfo: {},
  unClosedPurchaseReturnCount: 0,
  unPaidPurchaseReturnCount: 0
}
